import { useForm } from "react-hook-form";
import {
  IStudioRelationsWizardFormModel,
  studioRelationsFormDefaultValues,
  studioRelationsFormSchema,
} from "../models/studioRelationsWizardFormModel";
import { yupResolver } from "@hookform/resolvers/yup";
import { useEffect } from "react";
import { ISelectFieldModel } from "../../../../../common/components/forms/inputs/dropdown/models/selectFieldModel";

export const useStudioRelationsWizardForm = (
  allStudios?: ISelectFieldModel[]
) => {
  const form = useForm<IStudioRelationsWizardFormModel>({
    defaultValues: studioRelationsFormDefaultValues,
    resolver: yupResolver(studioRelationsFormSchema),
  });

  useEffect(() => {
    if (allStudios && allStudios?.length > 0) {
      const first = allStudios[0];
      const last = allStudios[allStudios.length - 1];

      form.setValue("firstStudioId", first.id);
      form.setValue("secondStudioId", last.id);
    }
  }, [allStudios]);

  return form;
};
